import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeTabsEditor = () => {
  const [tabs, setTabs] = useState([]); // Holds all tab objects (5)
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadIndex, setUploadIndex] = useState(null);

  const LANGS = ["En", "Ar", "Ku"];

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // ==================================================
  // LOAD ALL 5 TABS (3 LANGUAGE CALLS)
  // ==================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFTabsSection?lang=en`),
          axios.get(`${API_BASE}/api/VFTabsSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFTabsSection?lang=ku`),
        ]);

        const baseTabs = en.data.tabs.map((t, idx) => ({
          id: t.id,
          img: t.img,
          titleEn: en.data.tabs[idx].title,
          descEn: en.data.tabs[idx].desc,
          titleAr: ar.data.tabs[idx].title,
          descAr: ar.data.tabs[idx].desc,
          titleKu: ku.data.tabs[idx].title,
          descKu: ku.data.tabs[idx].desc,
        }));

        setTabs(baseTabs);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load tabs:", err);
      }
    };

    load();
  }, []);

  // ==================================================
  // HANDLE TEXT CHANGE
  // ==================================================
  const handleChange = (i, e) => {
    const updated = [...tabs];
    updated[i][e.target.name] = e.target.value;
    setTabs(updated);
  };

  // ==================================================
  // SAVE TEXT CHANGES FOR ALL TABS
  // ==================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(
        `${API_BASE}/api/VFTabsSection/1`,
        { tabs },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Tabs updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to update.");
    }
  };

  // ==================================================
  // UPLOAD IMAGE FOR ONE TAB
  // ==================================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("Images", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VFTabsSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image uploaded!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE – Tabs Section Editor</h2>

      {/* =============================== */}
      {/*      TEXT EDIT FOR 5 TABS       */}
      {/* =============================== */}

      {tabs.map((t, i) => (
        <div className="card shadow-sm mb-4" key={i}>
          <div className="card-body">
            <h4 className="fw-bold mb-3">Tab #{i + 1}</h4>

            {/* IMAGE PREVIEW */}
            <img
              src={resolveUrl(t.img)}
              alt=""
              className="w-100 mb-3 rounded"
              style={{ maxHeight: "240px", objectFit: "cover" }}
            />

            <button
              className="btn btn-primary mb-4"
              onClick={() => {
                setUploadIndex(i);
                setUploadFile(null);
                setShowModal(true);
              }}
            >
              Upload / Replace Tab Image
            </button>

            {/* LANGUAGE CARDS */}
            <div className="row">
              {LANGS.map((l) => (
                <div className="col-lg-4 col-md-6 mb-3" key={l}>
                  <div className="border rounded p-3">
                    <h5 className="text-primary mb-3">{l} Version</h5>

                    <label className="form-label">Title</label>
                    <input
                      className="form-control mb-2"
                      name={`title${l}`}
                      value={t[`title${l}`]}
                      onChange={(e) => handleChange(i, e)}
                    />

                    <label className="form-label">Description</label>
                    <textarea
                      rows={4}
                      className="form-control"
                      name={`desc${l}`}
                      value={t[`desc${l}`]}
                      onChange={(e) => handleChange(i, e)}
                    ></textarea>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* SAVE BUTTON */}
      <div className="text-end">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save All Tabs
        </button>
      </div>

      {/* =============================== */}
      {/*              MODAL              */}
      {/* =============================== */}

      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Upload Image for Tab #{uploadIndex + 1}</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Backdrop */}
          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahFreeTabsEditor;
